import React, { useEffect, useState } from "react";
import { DragDropContext } from "@hello-pangea/dnd";
import InputDrawer from "./InputDrawer";
import SectionsContainer from "./SectionsContainer";
import { ReactComponent as EmailTextIcon } from "../../assets/images/icons/EmailTextIcon.svg";
import { ReactComponent as HyperlinkIcon } from "../../assets/images/icons/HyperlinkIcon.svg";
import { ReactComponent as SortTextIcon } from "../../assets/images/icons/SortTextIcon.svg";
import { ReactComponent as LongTextIcon } from "../../assets/images/icons/LongText.svg";
import { ReactComponent as URLIcon } from "../../assets/images/icons/UrlIcon.svg";
import { ReactComponent as DateTimeIcon } from "../../assets/images/icons/DatendTime.svg";
import { ReactComponent as PersonnIcon } from "../../assets/images/icons/person.svg";
import { ReactComponent as DateIcon } from "../../assets/images/icons/date.svg";
import { ReactComponent as NumberIcon } from "../../assets/images/icons/number.svg";
import { ReactComponent as DollarIcon } from "../../assets/images/icons/DollarIcon.svg";
import { ReactComponent as Percentage } from "../../assets/images/icons/Percentage.svg";
import { ReactComponent as CheckMark } from "../../assets/images/icons/CheckMark.svg";
import { ReactComponent as tagsIcon } from "../../assets/images/icons/TagsIconInput.svg";
import { ReactComponent as FadeDelete } from "../../assets/images/icons/FadeDelete.svg";
import { ReactComponent as LeftBlueArrow } from "../../assets/images/icons/LeftBlueArrow1.svg";
import { ReactComponent as TemplateIcon } from "../../assets/images/icons/Temp_task.svg";
import { ReactComponent as Deletecustomization } from "../../assets/images/delete-customization.svg";
import { ReactComponent as Sendcustomization } from "../../assets/images/send-customization.svg";
import { ReactComponent as MoveDraftcustomization } from "../../assets/images/MoveDraft-customization.svg";
import InputModal from "./InputModal";
import SectionModal from "./SectionModal";
import {
  addInput,
  addNewSection,
  deleteInput,
  deleteSection,
  deployTemplate,
  getTemplateDetails,
  updateInput,
  updateSection,
  updateTemplateDetails,
} from "../../utils/api/customTemplatesApi";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import { usePostApiMutation } from "../../utils/customer/customerTaskTable";
import { NODE_URL } from "../../utils/constants";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import {
  useDeleteFieldMutation,
  useDeleteLinkedSectionMutation,
  useDeleteSectionMutation,
  useDeleteTemplateMutation,
  useFetchAllSectionsQuery,
  useFetchSectionAndFieldsQuery,
  useLazyFetchLinkedSectionsFieldsQuery,
  useLazyFetchLinkedSectionsQuery,
  useLazyFetchSectionAndFieldsQuery,
} from "../../utils/customer/customerSelect";
import { useLocation, useNavigate } from "react-router-dom";
import DeployedDialog from "../CustomModule/DeployedDialog";
import Button from "../UniversalComponents/DefaultButton";
import ConfirmationDialog from "../UniversalComponents/ConformationDialog";
import { color, hover } from "framer-motion";
import { useFetchFunnelTypeQuery, useLazyFetchFunnelTypeQuery } from "../../utils/customer/funnelSlice";
import { getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import DynamicAddTaskPodModal from "../Task/DynamicAddTaskPodModal";
import TaskExtendView from "../Task/TaskExtendView";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import ConfirmationDialogMulti from "../UniversalComponents/ConfirmationDialogMulti";
import MotionTyping from "../UniversalComponents/MotionTyping";
import HeaderSkeleton from "../UniversalComponents/CustomTempModuleSkeleton";
import Skeleton from "../UniversalComponents/CustomTempModuleSkeleton";

export const INITIAL_INPUTS = [
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "email",
    inputName: "Email",
    baseInputType: "text",
    svg: EmailTextIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "shortText",
    baseInputType: "text",
    inputName: "Short Text",
    svg: SortTextIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "longText",
    baseInputType: "text",
    inputName: "Long Text",
    svg: LongTextIcon,
  },
  // {
  //   inputId: "",
  //   inputValue: "",
  //   inputDescription: "",
  //   inputType: "hyperlink",
  //   inputName: "Hyperlink",
  //   baseInputType: "text",
  //   svg: HyperlinkIcon,
  // },
  // {
  //   inputId: "",
  //   inputValue: "",
  //   inputDescription: "",
  //   baseInputType: "text",
  //   inputType: "url",
  //   inputName: "URL",
  //   svg: URLIcon,
  // },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "number",
    inputName: "Number",
    baseInputType: "number",
    svg: NumberIcon,
  },
  // {
  //   inputId: "",
  //   inputValue: "",
  //   inputDescription: "",
  //   inputType: "currency",
  //   inputName: "Currency",
  //   baseInputType: "number",
  //   svg: DollarIcon,
  // },
  // {
  //   inputId: "",
  //   inputValue: "",
  //   inputDescription: "",
  //   inputType: "percentage",
  //   inputName: "Percentage",
  //   baseInputType: "number",
  //   svg: Percentage,
  // },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "date",
    inputType: "date",
    inputName: "Date",
    svg: DateIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "datetime",
    inputName: "Date & Time",
    baseInputType: "date",
    svg: DateTimeIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "dropdown",
    inputType: "choice",
    inputName: `Choice`,
    svg: CheckMark,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "person",
    inputName: "Person",
    baseInputType: "person",
    svg: PersonnIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "dropdown",
    inputType: "tags",
    inputName: `Tags`,
    svg: tagsIcon,
  },
];

const INITIAL_DRAWER_PERMISSIONS = [
  {
    label: "Create",
    value: true,
    component: ({
      sections,
      onEditSection,
      onDeleteSection,
      onEditInput,
      onDeleteInput,
      setSectionNameModal,
      handleEditSection,
    }) => (
      <SectionsContainer
        sections={sections}
        onEditSection={onEditSection}
        onDeleteSection={onDeleteSection}
        onEditInput={onEditInput}
        onDeleteInput={onDeleteInput}
        setSectionNameModal={setSectionNameModal}
        handleEditSection={handleEditSection}
      />
    ),
    showInInputSection: false,
  },
];

// ================================
// Main App
// ================================
export const TemplateBuilder = ({ templateId }) => {
  const [sections, setSections] = useState([]);
  const [customApiData, setCustomApiData] = useState({});
  const [sectionNameModal, setSectionNameModal] = useState(false);
  const [showDeployedDialog, setShowDeployedDialog] = useState(false);
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [getAllFunnel, setGetAllFunnel] = useState(null);
  const [selectedfunnel, setSelectedFunnel] = useState(null);
  const [toggleLinkSection, setToggleLinkSection] = useState(null);
  const urlTemplateId = useLocation().pathname.split("/")[3];
  const [secondPopupOpen, setSecondPopupOpen] = useState(false);
  const [isConfirmDraft, setIsConfirmDraft] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dragCapture, setDragCapture] = useState({ isOpen: false, data: {} });

  const [inputPermissionList, setInputPermissionList] = useState(INITIAL_DRAWER_PERMISSIONS || []);
  const [sectionList, setSectionsList] = useState([]);
  const [linkedSections, setLinkedSections] = useState(null);
  const [activeTab, setActiveTab] = useState(INITIAL_DRAWER_PERMISSIONS[0]);

  const convertApiResponseToCustom = ({ apiData }) => {
    let data = apiData?.sections?.map((sectionInfo) => {
      return {
        sectionId: sectionInfo?.section_id,
        sectionName: sectionInfo?.section_name,
        sectionRank: sectionInfo?.section_rank,
        is_locked: sectionInfo?.is_locked,
        inputs: sectionInfo?.fields?.map((fieldInfo) => {
          return {
            inputId: fieldInfo?.field_id,
            inputValue: fieldInfo?.field_label,
            inputDescription: fieldInfo?.field_description,
            inputType: fieldInfo?.field_type,
            inputRank: fieldInfo?.field_rank,
            inputMeta: fieldInfo?.meta,
            inputUniqueName: fieldInfo?.field_name,
          };
        }),
      };
    });

    data = {
      sections: data,
      templateName: apiData?.template_name,
      isNotes: Boolean(apiData?.is_notes),
      isDocuments: Boolean(apiData?.is_documents),
      isTasks: Boolean(apiData?.is_task),
      isActive: Boolean(apiData?.is_active),
      isDeployed: Boolean(apiData?.is_deployed),
      isMultiRecord: Boolean(apiData?.is_multi_record),
      templateId: apiData?.template_id,
      templateName: apiData?.template_name,
      is_tag_exist: apiData?.is_tag_exist,
      color: apiData?.color || { from: "#086E74", to: "#0FCFDA" },
      icon: apiData?.icon || "bi bi-border-style",
    };

    return data;
  };

  const [
    AddUpdateTemplate,
    {
      data: templateAddUpdate,
      isLoading: isTemplateAddUpdateLoading,
      isError: isTemplateAddUpdateError,
      isSuccess: isTemplateAddUpdateSuccess,
      error: TemplateError,
    },
  ] = usePostApiMutation();

  useEffect(() => {
    try {
      if (isTemplateAddUpdateLoading) {
        dispatch(showLoader());
      } else {
        dispatch(hideLoader());
      }
      if (isTemplateAddUpdateSuccess) {
        dispatch(
          pushAlert({
            message: templateAddUpdate?.message,
            type: "success",
            visible: true,
          })
        );
        setShowDeployedDialog(true);
        RefetchAllSectionAndFields();
      }
    } catch (error) {
      dispatch(
        pushAlert({
          message: error?.message || "Something went wrong",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isTemplateAddUpdateSuccess, isTemplateAddUpdateLoading, isTemplateAddUpdateError]);

  // 1. Create/Update Section
  const [
    AddUpdateSection,
    {
      data: SectionData,
      isLoading: isSectionDataLoading,
      isError: isSectionDataError,
      isSuccess: isSectionDataSuccess,
      error: sectionError,
    },
  ] = usePostApiMutation();

  //2 get all the section and Fields;
  const [
    GetAllSectionAndFields,
    {
      data: AllSectionListData,
      isLoading: isAllSectionsListLoading,
      isError: isAllSectionsListError,
      isSuccess: isAllSectionsListSuccess,
      error: AllSectionsListError,
      refetch: RefetchfetchSectionFields,
    },
  ] = useLazyFetchSectionAndFieldsQuery();

  console.log("AllSectionListData", AllSectionListData);

  //3 . Delete Section
  const [
    DeleteSection,
    {
      data: DeleteSectionData,
      isLoading: isDeleteSectionLoading,
      isError: isDeleteSectiondError,
      isSuccess: isDeleteSectiondSuccess,
      error: DeleteSectiondError,
    },
  ] = useDeleteSectionMutation();

  //4. Delete Field
  const [
    DeleteField,
    {
      data: DeleteFieldData,
      isLoading: isDeleteFieldLoading,
      isError: isDeleteFieldError,
      isSuccess: isDeleteFieldSuccess,
      error: DeleteFieldError,
    },
  ] = useDeleteFieldMutation();

  const [
    AddUpdateField,
    {
      data: FieldData,
      isLoading: isFieldDataLoading,
      isError: isFieldDataError,
      isSuccess: isFieldDataSuccess,
      error: fieldError,
    },
  ] = usePostApiMutation();
  // 5. Fetch all linked sections with template
  const [
    FetchAllLinkedSections,
    {
      data: GetAllLinkedSections,
      isLoading: isGetAllLinkedSectionsLoading,
      isError: isGetAllLinkedSectionsError,
      isSuccess: isGetAllLinkedSectionsSuccess,
      error: GetAllLinkedSectionsError,
    },
  ] = useLazyFetchLinkedSectionsQuery();

  // 6. Delete Linked Section
  const [
    DeleteLinking,
    {
      data: deletedLinkedSection,
      isLoading: isDeletedLinkedSectionLoading,
      isError: isDeletedLinkedSectionError,
      isSuccess: isDeletedLinkedSectionSuccess,
      error: deletedLinkedSectionError,
    },
  ] = useDeleteLinkedSectionMutation();
  // 7. Section linking
  const [
    SectionLinking,
    {
      data: SelectionLink,
      isLoading: isSelectionLinkLoading,
      isError: isSelectionLinkError,
      isSuccess: isSelectionLinkSuccess,
      error: SelecrtionLinkError,
    },
  ] = usePostApiMutation();
  // Delete Template
  const [
    DeleteTemplate,
    {
      data: DeleteTemplateData,
      isLoading: isDeleteTemplateLoading,
      isError: isDeleteTemplatedError,
      isSuccess: isDeleteTemplatedSuccess,
      error: DeleteTemplatedError,
    },
  ] = useDeleteTemplateMutation();

  //fetch funnel type
  const [
    fetchFunnelTypes,
    {
      data: funnelType,
      isLoading: isFunnelTypeLoading,
      isSuccess: isFunnelTypeSuccess,
      isError: isFunnelTypeError,
      error: funnelTypeError,
    },
  ] = useLazyFetchFunnelTypeQuery();

  const handleDeleteTemplate = () => {
    DeleteTemplate({ TemplateId: templateId });
  };

  //handle funnel type
  useEffect(() => {
    if (isFunnelTypeLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    if (isFunnelTypeSuccess && funnelType?.status) {
      setGetAllFunnel(funnelType?.data);
    } else if (isFunnelTypeError) {
      dispatch(
        pushAlert({
          message: funnelTypeError?.data?.message,
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isFunnelTypeLoading, isFunnelTypeSuccess, funnelType]);

  // 🔁 HANDLE DELETE TEMPLATE
  useEffect(() => {
    if (isDeleteTemplateLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeleteTemplatedSuccess && DeleteTemplateData?.status) {
      dispatch(
        pushAlert({
          message: DeleteTemplateData.message || "Template deleted successfully",
          type: "success",
          visible: true,
        })
      );
      navigate("/setting/customization");
      setIsConfirmDelete(false); // close confirmation dialog
    } else if (isDeleteTemplatedError) {
      dispatch(
        pushAlert({
          message: DeleteTemplatedError?.data?.message || "Error deleting template",
          type: "danger",
          visible: true,
        })
      );
    }
    setIsConfirmDelete(false);
  }, [
    isDeleteTemplateLoading,
    isDeleteTemplatedSuccess,
    isDeleteTemplatedError,
    DeleteTemplateData,
    DeleteTemplatedError,
  ]);
  useEffect(() => {
    if (isGetAllLinkedSectionsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isGetAllLinkedSectionsSuccess && GetAllLinkedSections?.success) {
      setLinkedSections(GetAllLinkedSections?.data || []);
    } else if (isGetAllLinkedSectionsError) {
      dispatch(
        pushAlert({
          message: GetAllLinkedSectionsError?.data?.message || "Error fetching linked sections",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isGetAllLinkedSectionsLoading,
    isGetAllLinkedSectionsSuccess,
    isGetAllLinkedSectionsError,
    GetAllLinkedSections?.data,
  ]);

  // HANDLE LINKING SECTION with Template
  useEffect(() => {
    if (isSelectionLinkLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isSelectionLinkSuccess && SelectionLink?.success) {
      dispatch(pushAlert({ message: SelectionLink?.message, type: "success", visible: true }));
      FetchAllLinkedSections({ TemplateId: templateId });
      RefetchAllSectionAndFields();
    } else if (isSelectionLinkError) {
      dispatch(
        pushAlert({
          message: SelecrtionLinkError?.data?.message || "Error linking section",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isSelectionLinkLoading, isSelectionLinkSuccess, isSelectionLinkError]);

  useEffect(() => {
    FetchAllLinkedSections({ TemplateId: templateId });
    fetchFunnelTypes({ is_deployed: true });
  }, []);

  const RefetchAllSectionAndFields = async () => {
    const response = await GetAllSectionAndFields({ TemplateId: templateId });
  };

  const {
    data: AllSections,
    refetch: RefetchAllSections,
    isError: isAllSectionsError,
    isSuccess: isAllSectionsSuccess,
    error: AllSectionsError,
  } = useFetchAllSectionsQuery();

  // 🔁 HANDLE GET ALL SECTIONS
  useEffect(() => {
    if (isAllSectionsSuccess && AllSections?.success) {
      setSectionsList(AllSections?.data);
      dispatch(pushAlert({ message: AllSections.message, type: "success", visible: true }));
    }

    if (isAllSectionsError) {
      dispatch(
        pushAlert({
          message: AllSectionsError?.data?.message || "Error fetching sections",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [AllSections, isAllSectionsSuccess, isAllSectionsError]);

  useEffect(() => {
    if (isAllSectionsListLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isAllSectionsListSuccess && AllSectionListData?.status) {
      dispatch(
        pushAlert({
          message: AllSectionListData?.message || "Section fields fetched successfully",
          type: "success",
          visible: true,
        })
      );
      if (AllSectionListData?.data) {
        const data = convertApiResponseToCustom({ apiData: AllSectionListData?.data });
        const { sections, ...rest } = data;
        setCustomApiData(rest);
        setSections(data?.sections);
        // setInputPermissionList([
        //   {
        //     label: "Create",
        //     value: true,
        //     component: ({ sections, onEditSection, onDeleteSection, onEditInput, onDeleteInput }) => (
        //       <SectionsContainer
        //         sections={sections}
        //         onEditSection={onEditSection}
        //         onDeleteSection={onDeleteSection}
        //         onEditInput={onEditInput}
        //         onDeleteInput={onDeleteInput}
        //         setSectionNameModal={setSectionNameModal}
        //         getAllFunnel={getAllFunnel}
        //         selectedfunnel={selectedfunnel}
        //         setSelectedFunnel={setSelectedFunnel}
        //         templateId={data && data?.templateId}
        //         isDeployed={data && data?.isDeployed}
        //       />
        //     ),
        //     showInInputSection: false,
        //   },
        // ]);
      }
    }

    if (isAllSectionsListError) {
      dispatch(
        pushAlert({
          message: AllSectionsListError?.data?.message || "Failed to fetch section fields",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isAllSectionsListLoading,
    isAllSectionsListSuccess,
    isAllSectionsListError,
    AllSectionListData?.data,
    urlTemplateId,
  ]);

  useEffect(() => {
    GetAllSectionAndFields({ TemplateId: templateId });
  }, [templateId, urlTemplateId]);

  // 🔁 HANDLE ADD/UPDATE SECTION
  useEffect(() => {
    if (isSectionDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isSectionDataSuccess && SectionData?.success) {
      dispatch(pushAlert({ message: SectionData.message, type: "success", visible: true }));

      GetAllSectionAndFields({ TemplateId: templateId });

      // RefetchAllSections();
      // FetchSectionFields({ sectionId: sectionDetails?.id });
      setSectionNameModal(false);
    } else if (isSectionDataError) {
      dispatch(
        pushAlert({ message: sectionError?.data?.message || "Error adding section", type: "danger", visible: true })
      );
    }
  }, [isSectionDataLoading, isSectionDataSuccess, isSectionDataError]);

  // 🔁 HANDLE DELETE SECTION
  useEffect(() => {
    if (isDeleteSectionLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeleteSectiondSuccess && DeleteSectionData?.status) {
      dispatch(
        pushAlert({
          message: DeleteSectionData.message || "Section deleted successfully",
          type: "success",
          visible: true,
        })
      );
      RefetchAllSectionAndFields(); // refresh list after delete
    } else if (isDeleteSectiondError) {
      dispatch(
        pushAlert({
          message: DeleteSectiondError?.data?.message || "Error deleting section",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isDeleteSectionLoading, isDeleteSectiondSuccess, isDeleteSectiondError, DeleteSectionData, DeleteSectiondError]);

  useEffect(() => {
    if (isFieldDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isFieldDataSuccess && FieldData?.status) {
      RefetchAllSectionAndFields();
      setDragCapture({ isOpen: false, data: {} });
    } else if (isFieldDataError) {
      dispatch(
        pushAlert({ message: fieldError?.data?.message || "Error adding field", type: "danger", visible: true })
      );
    }
    setSectionNameModal(false);
  }, [isFieldDataLoading, isFieldDataSuccess, isFieldDataError, FieldData?.data]);
  // 🔁 HANDLE DELETE FIELD
  useEffect(() => {
    if (isDeleteFieldLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeleteFieldSuccess && DeleteFieldData?.status) {
      dispatch(
        pushAlert({
          message: DeleteFieldData.message || "Field deleted successfully",
          type: "success",
          visible: true,
        })
      );
      RefetchAllSectionAndFields();
    } else if (isDeleteFieldError) {
      dispatch(
        pushAlert({
          message: DeleteFieldError?.data?.message || "Error deleting field",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isDeleteFieldLoading, isDeleteFieldSuccess, isDeleteFieldError, DeleteFieldData, DeleteFieldError]);

  // HANDLE delete LINKING SECTION with Template
  useEffect(() => {
    if (isDeletedLinkedSectionLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeletedLinkedSectionSuccess && deletedLinkedSection?.success) {
      dispatch(pushAlert({ message: deletedLinkedSection?.message, type: "success", visible: true }));
      FetchAllLinkedSections({ TemplateId: templateId }); // Refresh linked sections
      RefetchAllSectionAndFields(); // Refresh sections
    } else if (isDeletedLinkedSectionError) {
      dispatch(
        pushAlert({
          message: deletedLinkedSectionError?.data?.message || "Error unlinking section",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isDeletedLinkedSectionLoading, isDeletedLinkedSectionSuccess, isDeletedLinkedSectionError]);

  useEffect(() => {
    setInputPermissionList([
      {
        label: "Create",
        value: true,
        component: ({ sections, onEditSection, onDeleteSection, onEditInput, onDeleteInput }) => (
          <SectionsContainer
            sections={sections}
            onEditSection={onEditSection}
            onDeleteSection={onDeleteSection}
            onEditInput={onEditInput}
            onDeleteInput={onDeleteInput}
            setSectionNameModal={setSectionNameModal}
            getAllFunnel={getAllFunnel}
            selectedfunnel={selectedfunnel}
            setSelectedFunnel={setSelectedFunnel}
            handleEditSection={handleEditSection}
            templateId={customApiData && customApiData?.templateId}
            isDeployed={customApiData && customApiData?.isDeployed}
          />
        ),
        showInInputSection: false,
      },
    ]);
  }, [
    selectedfunnel,
    getAllFunnel,
    AllSectionListData?.sections,
    AllSectionListData?.data,
    urlTemplateId,
    customApiData?.isDeployed,
    sections,
  ]);

  const handleDeploy = async () => {
    try {
      if (!customApiData?.isDeployed) {
        const response = await deployTemplate({
          body: {
            id: templateId,
            is_deployed: true,
            scope: "task",
          },
        });

        await AddUpdateTemplate({
          data: {
            id: templateId,
            template_name: customApiData?.templateName,
            funnel_type: selectedfunnel?.value,
          },
          url: `${NODE_URL}template/create`,
        });

        if (response?.status) {
          RefetchAllSectionAndFields();
          dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
          setShowDeployedDialog(true);
          // navigate("/setting/customization");
        } else {
          dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
        }

        // CASE 3: No funnel info or link section off → show alert
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: "Please add 'Funnel Information' section to deploy the template",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleDragEnd = (result) => {
    const { source, destination, draggableId, type } = result;

    if (!destination) return;

    // Dragging sections
    if (type === "SECTION") {
      const newSections = Array.from(sections);
      const [moved] = newSections.splice(source.index, 1);
      newSections.splice(destination.index, 0, moved);
      setSections(newSections);
      return;
    }

    // Dragging inputs
    if (type === "INPUT") {
      if (destination.droppableId === "INPUT_DRAWER") return;

      // From drawer to section
      if (source.droppableId === "INPUT_DRAWER") {
        const inputInfo = INITIAL_INPUTS.find((i) => i.inputType === draggableId);
        const sectionId = result?.destination?.droppableId;
        const sectionInfo = sections.find((s) => s.sectionId === sectionId);

        // "result" consist the data about whom to drop and where to drop.(Ids of them)

        const data = {
          inputId: null,
          inputValue: null,
          inputDescription: null,
          inputType: inputInfo?.inputType,
          inputName: inputInfo?.inputName,
          // baseInputType: inputInfo?.baseInputType,
          sectionId: sectionInfo?.sectionId,
          sectionName: sectionInfo?.sectionName,
          // sectionRank: destination.index,
        };

        setDragCapture({ isOpen: true, data });
        // const targetSectionIndex = sections.findIndex(
        //   (s) => s.id === destination.droppableId
        // );
        // const newSections = Array.from(sections);
        // const inputTemplate = INITIAL_INPUTS.find((i) => i.id === draggableId);
        // const newInput = {
        //   ...inputTemplate,
        //   uniqueId: `${inputTemplate.id}-${Date.now()}`,
        // };
        // newSections[targetSectionIndex].inputs.splice(
        //   destination.index,
        //   0,
        //   newInput
        // );
        // setSections(newSections);
        return;
      }

      // Move/reorder inside or across sections
      // const sourceSectionIndex = sections.findIndex((s) => s.sectionId === source.droppableId);
      // const destSectionIndex = sections.findIndex((s) => s.sectionId === destination.droppableId);

      if (source.droppableId === destination.droppableId) {
        dispatch(pushAlert({ visible: true, message: "Cannot move input to same section", type: "info" }));
      } else {
        // field input shifting
        // handleSwapSectionsOfInput({
        //   newSectionId: destination.droppableId,
        //   inputId: draggableId,
        // });
      }

      // const newSections = Array.from(sections);
      // const [moved] = newSections[sourceSectionIndex].inputs.splice(source.index, 1);
      // newSections[destSectionIndex].inputs.splice(destination.index, 0, moved);
      // setSections(newSections);
    }
  };

  const handleSwapSectionsOfInput = async ({ newSectionId, inputId }) => {
    try {
      const response = await updateInput({ body: { section_id: newSectionId, id: inputId } });
      if (response?.status) {
        // getSectionsAndInputByTemplateId(); refetch the sections fields
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message || "Something went wrong", type: "danger" }));
      }
      setDragCapture({
        isOpen: false,
        data: {},
      });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleAddInput = async (formInputData) => {
    console.log("formInputData", formInputData);
    try {
      const inputInfo = INITIAL_INPUTS.find((i) => i.inputType === formInputData?.type);
      let body = {
        field_label: formInputData?.name,
        description: formInputData?.description,
        section_id: formInputData?.sectionId,
        field_type: inputInfo?.baseInputType,
      };

      if (formInputData?.inputId) {
        body.id = formInputData?.inputId;
      }

      // ---------- FOR CHOICE/MULTISELECT -----------------------------------------
      if ((formInputData?.type === "choice" && formInputData?.allowMultiple) || formInputData?.inputId) {
        body = { ...body, field_type: "multiselect" };
      } else if ((formInputData?.type === "choice" && !formInputData?.allowMultiple) || formInputData?.inputId) {
        body = { ...body, field_type: "dropdown" };
      } else if (formInputData?.type === "tags") {
        body = { ...body, field_type: "tags", field_label: "Tag", description: "tags" };
      }
      // ---------- FOR CHOICE/MULTISELECT -----------------------------------------

      // ---------- FOR PERSON/MULTIPERSON -----------------------------------------
      if (formInputData?.type === "person" && formInputData?.multiPerson) {
        body = { ...body, field_type: "multi_person" };
      } else if (formInputData?.type === "person" && !formInputData?.multiPerson) {
        body = { ...body, field_type: "person" };
      }
      // ---------- FOR PERSON/MULTIPERSON -----------------------------------------

      let meta = {
        dateTimeFormat: {
          timeDisplay: null, // Date & Time , Date
        },
        numberFormat: {
          decimalPlaces: formInputData?.decimalPlaces,
          negativeFormat: formInputData?.negativeNumber,

          // selectedOption: "Currency",
          separators: formInputData?.separatorInput,
          symbol: formInputData?.symbol,
        },
        textFormat: {
          textSelectedOption: null,
        },
        absoluteType: formInputData?.type,
      };

      if (formInputData?.type === "email") {
        meta = { ...meta, textFormat: { textSelectedOption: "Email" } };
      } else if (formInputData?.type === "shortText") {
        meta = { ...meta, textFormat: { textSelectedOption: "Short Text" } };
      } else if (formInputData?.type === "longText") {
        meta = { ...meta, textFormat: { textSelectedOption: "Long Text" } };
      } else if (formInputData?.type === "hyperlink") {
        meta = { ...meta, textFormat: { textSelectedOption: "Hyperlink" } };
      } else if (formInputData?.type === "url") {
        meta = { ...meta, textFormat: { textSelectedOption: "URL" } };
      } else if (formInputData?.type === "datetime") {
        meta = { ...meta, dateTimeFormat: { timeDisplay: "Date & Time" } };
      } else if (formInputData?.type === "date") {
        meta = { ...meta, dateTimeFormat: { timeDisplay: "Date" } };
      } else if (formInputData?.type === "choice") {
        body.dropdown_options = formInputData?.options?.map((option) => {
          return {
            color_code: option?.color_code,
            label: option?.value,
          };
        });
      } else if (formInputData?.type === "tags") {
        body.dropdown_options = formInputData?.options?.map((option) => {
          return {
            color_code: option?.color_code,
            label: option?.value,
          };
        });
      }

      if (body.field_type !== "tags" && body.field_label.toLowerCase() === "tags") {
        dispatch(
          pushAlert({
            visible: true,
            message: "Tags field name is not allowed",
            type: "danger",
          })
        );

        return;
      }

      AddUpdateField({ data: { ...body, meta }, url: `${NODE_URL}template/section/field/create` });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleDeleteSection = async (sectionId) => {
    // setSections(sections.filter((s) => s.sectionId !== sectionId));

    try {
      DeleteSection({ SectionId: sectionId });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleDeleteInput = async (sectionId, inputId) => {
    try {
      DeleteField({ field_value: inputId });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleAddSection = async ({ inputs }) => {
    try {
      if (!inputs?.name?.trim()) {
        setSectionNameModal(false);
        dispatch(pushAlert({ visible: true, message: "Please enter section name", type: "danger" }));
        return;
      }

      const payload = {
        section_name: inputs?.name,
        template_id: templateId,
      };

      AddUpdateSection({ data: payload, url: `${NODE_URL}template/section` });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleEditSection = async ({ event, sectionId, sectionName, sectionDescription, templateId }) => {
    try {
      if (!sectionName?.trim()) {
        setSectionNameModal(false);
        dispatch(pushAlert({ visible: true, message: "Please enter section name", type: "danger" }));
        return;
      }

      const payload = {
        id: sectionId,
        section_name: sectionName,
        template_id: templateId,
      };

      AddUpdateSection({ data: payload, url: `${NODE_URL}template/section` });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleEditInputDialog = (input) => {
    const inputTypeInfo = INITIAL_INPUTS.find((i) => i.inputType === input.inputType);

    setDragCapture({
      isOpen: true,
      data: {
        inputId: input.inputId,
        inputValue: input.inputValue,
        inputDescription: input.inputDescription,
        inputType: input.inputType,
        inputName: inputTypeInfo?.inputName,
        sectionId: input.sectionId,
        sectionName: input.sectionName,
        inputMeta: input.inputMeta,
        inputUniqueName: input.inputUniqueName,
      },
    });
  };
  const handleEditTask = async () => {
    if (customApiData?.isDeployed) {
      await AddUpdateTemplate({
        data: {
          id: templateId,
          template_name: customApiData?.templateName,
          funnel_type: selectedfunnel?.value,
        },
        url: `${NODE_URL}template/create`,
      });

      const response = await deployTemplate({
        body: {
          id: templateId,
          is_deployed: false,
          scope: "task",
        },
      });

      if (response?.status) {
        RefetchAllSectionAndFields();
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
        setShowDeployedDialog(true);
        setIsConfirmDraft(false);
        // navigate("/setting/customization");
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    }
  };

  //   try {
  //     const response = await getTemplateDetails({ params: { template_id: templateId } });
  //     if (response?.status) {
  //       const data = convertApiResponseToCustom({ apiData: response?.data });
  //       setInputPermissionList([
  //         {
  //           label: "Create",
  //           value: true,
  //           component: ({ sections, onEditSection, onDeleteSection, onEditInput, onDeleteInput }) => (
  //             <SectionsContainer
  //               sections={sections}
  //               onEditSection={onEditSection}
  //               onDeleteSection={onDeleteSection}
  //               onEditInput={onEditInput}
  //               onDeleteInput={onDeleteInput}
  //               setSectionNameModal={setSectionNameModal}
  //             />
  //           ),
  //           showInInputSection: false,
  //         },
  //         {
  //           label: "Notes",
  //           value: data?.isNotes,
  //           component: () => <NotesSection />,
  //           showInInputSection: true,
  //         },
  //         {
  //           label: "Documents",
  //           value: data?.isDocuments,
  //           component: () => <DocumentSection />,
  //           showInInputSection: true,
  //         },
  //         {
  //           label: "Task",
  //           value: data?.isTasks,
  //           component: () => <TaskSection />,
  //           showInInputSection: true,
  //         },
  //       ]);

  //       setCustomApiData(data);
  //       setSections(data?.sections);
  //     } else {
  //       dispatch(
  //         pushAlert({
  //           visible: true,
  //           message: response?.message,
  //           type: "danger",
  //         })
  //       );
  //     }
  //   } catch (error) {
  //     dispatch(
  //       pushAlert({
  //         visible: true,
  //         message: error?.message || "Something went wrong",
  //         type: "danger",
  //       })
  //     );
  //   }
  // };

  // link the section with Template
  const handleUpdateTemplatePermission = async (data, result) => {
    try {
      if (result) {
        DeleteLinking({ TemplateId: templateId, SectionId: data?.id });
        setToggleLinkSection(result);
      } else {
        SectionLinking({
          data: { template_id: templateId, section_id: data?.id },
          url: `${NODE_URL}template/link-section`,
        });
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  // useEffect(() => {
  //   getSectionsAndInputByTemplateId(); // get all the Sections api
  // }, []);
  const closeSecondPopup = () => {
    setSecondPopupOpen((prev) => !prev);
  };
  const handleOpenExtenedView = () => {
    setSecondPopupOpen(true);
  };

  console.log("customApiDataVinay", customApiData);
  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className="flex flex-col h-full gap-3">
          {isAllSectionsListSuccess ? (
            <div className="flex justify-between items-center">
              <div className="flex gap-3 items-center">
                <button
                  onClick={() => {
                    navigate("/setting/customization/task-template", { replace: true });
                  }}
                  className="text-primary py-1 rounded-md flex items-center"
                >
                  <LeftBlueArrow className="fill-[#13131399] hover:fill-primary" />{" "}
                  {/* <span className="px-1 font-600 text-base">{getTitleCase(customApiData?.templateName)}</span> */}
                </button>
                <div
                  style={{
                    background: `linear-gradient(to right, ${customApiData?.color?.from} 0%, ${customApiData?.color?.to} 100%)`,
                  }}
                  className="flex h-11 w-11 items-center justify-center rounded-xl text-white"
                >
                  <i className={`${customApiData?.icon} text-white text-2xl`}></i>
                </div>

                {/* task draft*/}
                <div className="flex flex-col gap-1 ">
                  <span className="flex gap-3 items-center">
                    <span className="text-base font-semibold text-primary">
                      {getTitleCase(customApiData?.templateName)}
                    </span>
                    {customApiData?.isDeployed ? (
                      <span className="text-[#3DB22A] bg-[#3DB22A1A] text-sm py-1 px-4 rounded-md">Deployed</span>
                    ) : (
                      <span className="text-[#1A1A1A] bg-[#F2F2F2] text-sm py-1 px-4 rounded-md pl-4">Draft</span>
                    )}
                  </span>
                  <span>
                    {customApiData?.isDeployed && (
                      <MotionTyping
                        text="To make edits, please move this to the draft section."
                        stagger={0.05}
                        initialDelay={0.2}
                        repeatDelay={0.2}
                      />
                    )}
                  </span>
                </div>
              </div>
              {/* header div right delete and Save and Deploy start */}
              <div className="flex gap-4 items-center justify-center">
                {!customApiData?.isDeployed && (
                  <>
                    <button
                      onClick={() => setIsConfirmDelete((prev) => !prev)}
                      className="bg-[#FFFFFF] hover:bg-[#FFF5F5] border border-[#FFE2E2] flex items-center gap-2 px-4 py-2.5 rounded-lg cursor-pointer"
                    >
                      <span>
                        <Deletecustomization />
                      </span>
                      <span className="text-sm font-medium text-[#E7000B] flex justify-center items-center">
                        Delete
                      </span>
                    </button>
                    <span className="h-[24px] w-0.5 border-l border-[#E2E8F0]"></span>
                  </>
                )}

                {customApiData?.isDeployed && (
                  <button
                    onClick={() => setIsConfirmDraft(true)}
                    className="bg-[#FFFFFF] hover:bg-[#F3F3F3] border border-[#E2E8F0] flex items-center gap-2 px-4 py-2.5 rounded-lg cursor-pointer"
                  >
                    <span>
                      <MoveDraftcustomization />
                    </span>
                    <span className="text-sm font-medium text-[#131313CC] flex justify-center items-center">
                      Move to draft
                    </span>
                  </button>
                )}
                {!customApiData?.isDeployed && (
                  <button
                    onClick={handleDeploy}
                    className="bg-primary-70 hover:bg-primary text-white flex items-center px-4 py-2 gap-2 rounded-lg shadow-sm cursor-pointer"
                  >
                    <span>
                      <Sendcustomization />
                    </span>
                    Save and Deploy
                  </button>
                )}
              </div>

              {/* me working in this code */}
            </div>
          ) : (
            <div className="w-full h-14">
              <Skeleton variant="header" />
            </div>
          )}

          <div className="flex min-h-0 grow gap-3 border-t">
            {/* Left Side - Sections */}
            <div className="w-[25%] h-full ">
              <InputDrawer
                sections={sections}
                inputs={INITIAL_INPUTS}
                sectionList={sectionList}
                setSectionsList={setSectionsList}
                linkedSections={linkedSections}
                setLinkedSections={setLinkedSections}
                setSectionNameModal={setSectionNameModal}
                handleUpdateTemplatePermission={handleUpdateTemplatePermission}
                isDeployed={customApiData?.isDeployed}
                is_tag_exist={customApiData?.is_tag_exist}
              />
            </div>

            {/* Right Side - Input Drawer */}
            <div className="w-full flex flex-col justify-between gap-2 min-h-0 grow">
              <div className="flex  ">
                {/* // ONLY SHOW THE TABS WHEN THE VALUE IS TRUE */}
                {inputPermissionList
                  ?.filter((item) => item.value)
                  .map((item, index) => (
                    <button
                      key={index}
                      className={`border-b-[2px] px-4 py-2 ${activeTab.label === item.label && "border-b-[2px] border-primary text-primary"}`}
                      onClick={() => setActiveTab(item)}
                    >
                      {item?.label}
                    </button>
                  ))}
              </div>

              <div className="min-h-0 grow overflow-auto thinscrollbar">
                {inputPermissionList
                  ?.filter((item) => item.value && activeTab?.label === item.label)
                  .map((item, index) => {
                    return (
                      <div>
                        {item.component({
                          sections: sections,
                          onEditSection: (section) => {
                            setSectionNameModal(section);
                          },
                          onDeleteSection: handleDeleteSection,
                          onEditInput: (sectionId, sectionName, input) => {
                            handleEditInputDialog({ sectionId, sectionName, ...input });
                          },
                          onDeleteInput: handleDeleteInput,
                          setSectionNameModal: setSectionNameModal,
                          handleEditSection: handleEditSection,
                        })}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          {sectionNameModal && (
            <SectionModal
              onClose={() => setSectionNameModal(false)}
              open={sectionNameModal}
              sectionInfo={sectionNameModal}
              handleSubmit={handleAddSection}
              handleEditSection={handleEditSection}
            />
          )}

          {dragCapture?.isOpen && (
            <InputModal
              // handleEditInput={handleEditInput}
              handleAddInput={handleAddInput}
              dragCapture={dragCapture}
              setDragCapture={setDragCapture}
            />
          )}

          {showDeployedDialog && (
            <DeployedDialog
              open={showDeployedDialog}
              onClose={() => setShowDeployedDialog(false)}
              isDeployed={customApiData?.isDeployed}
            />
          )}
          {isConfirmDelete && (
            <ConfirmationDialogMulti
              open={isConfirmDelete}
              onConfirm={() => handleDeleteTemplate()} //for api
              onClose={() => setIsConfirmDelete(false)}
              title="Delete Confirmation?"
              message={`Are you sure want to delete Template.`}
              confirmVariant="delete"
              confirmText="Delete"
              iconVariant="Delete"
              // cancelVariant="action"
              cancelText="Cancel"
              // variant="delete"
            />
          )}
          {isConfirmDraft && (
            <ConfirmationDialogMulti
              open={isConfirmDraft}
              onConfirm={() => handleEditTask()} //for api
              onClose={() => setIsConfirmDraft(false)}
              title="Draft Confirmation?"
              message={`Are you sure want to Draft Task.`}
              confirmVariant="draft"
              confirmText="Draft"
              iconVariant="discard"
              // cancelVariant="action"
              cancelText="Cancel"
              // variant="delete"
            />
          )}
        </div>
      </DragDropContext>

      {secondPopupOpen && ( //vinay
        <TaskExtendView
          templateId={urlTemplateId}
          isOpen={secondPopupOpen}
          closePopup={closeSecondPopup}
          onClose={closeSecondPopup}
          viewFor={getTitleCase(customApiData?.templateName)}
        />
      )}
    </>
  );
};
